module.exports = __webpack_public_path__ + "img/player-fullscreen-icon.06986c44.svg";